import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    if (isExpanded) {
      // Second click - open WhatsApp
      const phoneNumber = '817092702242';
      const message = encodeURIComponent('Hello! I am interested in your vehicles.');
      const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
      window.open(whatsappURL, '_blank', 'noopener,noreferrer');
      setIsExpanded(false); // Reset after opening
    } else {
      // First click - expand button
      setIsExpanded(true);
    }
  };

  return (
    <Button
      onClick={handleClick}
      className={`fixed bottom-24 right-8 z-50 rounded-full bg-green-500 hover:bg-green-600 shadow-lg flex items-center gap-2 transition-all duration-300 ${
        isExpanded ? 'h-14 px-6' : 'h-12 w-12 p-0 justify-center'
      }`}
      title="Chat with us on WhatsApp"
    >
      <MessageCircle className="h-5 w-5 text-white" />
      {isExpanded && <span className="text-white font-medium">WhatsApp</span>}
    </Button>
  );
};

export default WhatsAppButton;
